import { CoverPageHashSection, CoverPageHashSectionKey } from "./types"

export const COVER_PAGE_PADDING = {
  base: "30px",
  md: "50px"
}

/** Max width of the cover page card (`CoverPageSurface` / modal content). */
export const COVER_PAGE_MAX_WIDTH_PX = 1000

/** Rough width of `SignInLinkButton` on each side of the card. */
export const COVER_PAGE_SCREEN_SIGN_IN_BUTTON_WIDTH = "7rem"

/** One Chakra spacing unit (`1rem`) between card edge and sign-in control. */
export const COVER_PAGE_SCREEN_SIGN_IN_SIDE_MARGIN = "1rem"

/** Viewport must fit card + side margin + button on both sides (no overlap). */
export const COVER_PAGE_SCREEN_SIGN_IN_MIN_WIDTH = `calc(${COVER_PAGE_MAX_WIDTH_PX}px + 2 * ${COVER_PAGE_SCREEN_SIGN_IN_SIDE_MARGIN} + 2 * ${COVER_PAGE_SCREEN_SIGN_IN_BUTTON_WIDTH})`

export const COVER_PAGE_PANEL_PAGE_SIZE = 50
export const COVER_PAGE_PANEL_SEARCH_DEBOUNCE_MS = 250

export const COVER_PAGE_PANEL_ROOT_KEY = "cover"

export const COVER_PAGE_HASH_SECTION_KEYS = Object.values(
  CoverPageHashSection
) as CoverPageHashSectionKey[]

export const COVER_PAGE_SECTION_SCROLL_OFFSET = 150
export const COVER_PAGE_HIGHLIGHT_DURATION_MS = 1100
export const COVER_PAGE_HASH_RETRY = {
  maxAttempts: 20,
  intervalMs: 50
} as const

/** How far into the smooth scroll the section emphasis starts fading in. */
export const COVER_PAGE_SCROLL_EMPHASIS = {
  progress: 0.65,
  maxWaitMs: 1200
} as const
